<template>



	<div>
	    <div class="row">
	    	<a href="/club/events">Back to Club Events</a>
	    </div>
        <div class="row h1 page-header">
            Event&nbsp;Jobs
			<span class="pull-right">
			<a :href="`/club/events/${eventId}/volunteers`" class="btn btn-success">Volunteers</a>
			<button class="btn btn-primary" @click="showNewEventJobForm" v-show="!addMode">Add New Job</button>
            <button class="btn btn-danger" @click="hideNewEventJobForm" v-show="addMode">Cancel</button>
				</span>
    	</div>

        <v-event-info :event-id="eventId"></v-event-info>

		<v-event-job-form v-if="addMode" :event-id="eventId" @job-changed="reloadJobs()" :currentJob="currentJob"></v-event-job-form>

		<v-event-jobs-list ref="eventJobsList" :event-id="eventId" @job-edit="editJob($event)"></v-event-jobs-list>
	</div>
</template>

<script>
	export default {
		props: [
			'eventId'
		],

		data: function () {
			return {
				addMode: false,
				currentJob: null
			}
		},

		methods: {
			showNewEventJobForm() {
				this.addMode = true;
			},

			hideNewEventJobForm() {
				this.addMode = false;
				this.currentJob = null;
			},

			reloadJobs() {
				this.addMode = false;
				this.currentJob = null;
				this.$refs.eventJobsList.getEventJobs();
			},

			editJob(job) {
				this.addMode = true;
				this.currentJob = job;
			}
		}
	}
</script>

